import {
  SCHEDULING,
  SCHEDULING_EVENTS_create,
  SCHEDULING_EVENTS_read,
  SCHEDULING_EVENTS_update,
  SCHEDULING_EVENTS_delete,
  SCHEDULING_EVENTS_RESPONSES_OWN_update,
  SCHEDULING_EVENTS_RESPONSES_OTHER_read,
  SCHEDULING_EVENTS_RESPONSES_write,
  // SCHEDULING_EVENTS_rueckmeldungNachFrist,
  AVAILABILITY_REQUESTS_create,
  AVAILABILITY_REQUESTS_read,
  AVAILABILITY_REQUESTS_update,
  AVAILABILITY_REQUESTS_delete,
  AVAILABILITY_REQUESTS_RESPONSES_OWN_update,
  AVAILABILITY_REQUESTS_RESPONSES_OTHER_read,
  AVAILABILITY_REQUESTS_RESPONSES_write,
  SCHEDULING_ARCHIVE_read,
  SCHEDULING_CONFIG_read,
  SCHEDULING_CONFIG_GENERAL_read,
  SCHEDULING_CONFIG_EVENT_TYPES_create,
  SCHEDULING_CONFIG_EVENT_TYPES_read,
  SCHEDULING_CONFIG_EVENT_TYPES_update,
  SCHEDULING_CONFIG_EVENT_TYPES_delete,
  AVAILABILITY_CONFIG_REQUEST_TYPES_create,
  AVAILABILITY_CONFIG_REQUEST_TYPES_read,
  AVAILABILITY_CONFIG_REQUEST_TYPES_update,
  AVAILABILITY_CONFIG_REQUEST_TYPES_delete,
  SCHEDULING_CONFIG_EVENT_TEMPLATES_create,
  SCHEDULING_CONFIG_EVENT_TEMPLATES_read,
  SCHEDULING_CONFIG_EVENT_TEMPLATES_update,
  SCHEDULING_CONFIG_EVENT_TEMPLATES_delete,
  SCHEDULING_CALENDAR_read,
  SCHEDULING_CALENDAR_FEEDS_read,
  SCHEDULING_TEAMPLANNER_read,
} from "@/data/permission-types.js";

export const scheduling = {
  id: `${SCHEDULING}`,
  name: "Terminplanung",
  disabled: false,
  info: "",
  icon: "mdi-calendar",
  children: [
    {
      id: "terminplanung.veranstaltungen",
      name: "Veranstaltungen",
      disabled: false,
      chipsName: "Veranstaltungen",
      info: "",
      icon: "",
      children: [
        {
          id: `${SCHEDULING_EVENTS_create}`,
          name: "Veranstaltungen erstellen",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Erstellen)",
          info: "",
          icon: "mdi-plus-circle",
        },
        {
          id: `${SCHEDULING_EVENTS_read}`,
          name: "Veranstaltungen lesen",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Lesen)",
          info: "",
          icon: "mdi-eye-circle",
        },
        {
          id: `${SCHEDULING_EVENTS_update}`,
          name: "Veranstaltungen bearbeiten",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Bearbeiten)",
          info: "",
          icon: "mdi-pencil-circle",
        },
        {
          id: `${SCHEDULING_EVENTS_delete}`,
          name: "Veranstaltungen löschen",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Löschen)",
          info: "",
          icon: "mdi-delete-circle",
        },
        // Advanced permissions
        {
          id: `${SCHEDULING_EVENTS_RESPONSES_OWN_update}`,
          name: "Eigene Rückmeldung abgeben",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Eigene Rückmeldung)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
        {
          id: `${SCHEDULING_EVENTS_RESPONSES_OTHER_read}`,
          name: "Alle Rückmeldungen lesen",
          disabled: false,
          chipsName: "Terminplanung > Veranstaltungen (Rückmeldungen lesen)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
        {
          id: `${SCHEDULING_EVENTS_RESPONSES_write}`,
          name: "Alle Rückmeldungen verwalten",
          disabled: false,
          chipsName:
            "Terminplanung > Veranstaltungen (Rückmeldungen verwalten)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
      ],
    },
    {
      id: "verfuegbarkeit.abfragen",
      name: "Abfragen",
      disabled: false,
      chipsName: "Abfragen",
      info: "",
      icon: "",
      children: [
        {
          id: `${AVAILABILITY_REQUESTS_create}`,
          name: "Abfragen erstellen",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Erstellen)",
          info: "",
          icon: "mdi-plus-circle",
        },
        {
          id: `${AVAILABILITY_REQUESTS_read}`,
          name: "Abfragen lesen",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Lesen)",
          info: "",
          icon: "mdi-eye-circle",
        },
        {
          id: `${AVAILABILITY_REQUESTS_update}`,
          name: "Abfragen bearbeiten",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Bearbeiten)",
          info: "",
          icon: "mdi-pencil-circle",
        },
        {
          id: `${AVAILABILITY_REQUESTS_delete}`,
          name: "Abfragen löschen",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Löschen)",
          info: "",
          icon: "mdi-delete-circle",
        },
        // Advanced permissions
        {
          id: `${AVAILABILITY_REQUESTS_RESPONSES_OWN_update}`,
          name: "Eigene Rückmeldung abgeben",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Eigene Rückmeldung)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
        {
          id: `${AVAILABILITY_REQUESTS_RESPONSES_OTHER_read}`,
          name: "Alle Rückmeldungen lesen",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Rückmeldungen lesen)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
        {
          id: `${AVAILABILITY_REQUESTS_RESPONSES_write}`,
          name: "Alle Rückmeldungen verwalten",
          disabled: false,
          chipsName: "Verfügbarkeit > Abfragen (Rückmeldungen verwalten)",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
      ],
    },
    {
      id: "terminplanung.kalender",
      name: "Kalender",
      disabled: false,
      chipsName: "Terminplanung > Kalender",
      info: "",
      icon: "",
      children: [
        {
          id: `${SCHEDULING_CALENDAR_read}`,
          name: "Kalender lesen",
          disabled: false,
          chipsName: "Terminplanung > Kalender (Lesen)",
          info: "",
          dependencies: [`${SCHEDULING_EVENTS_read}`],
          icon: "mdi-eye-circle",
        },
        {
          id: `${SCHEDULING_CALENDAR_FEEDS_read}`,
          name: "Kalenderfeeds",
          disabled: false,
          chipsName: "Terminplanung > Kalender (Feeds))",
          info: "",
          icon: "mdi-dots-horizontal-circle",
        },
      ],
    },
    {
      id: `${SCHEDULING_TEAMPLANNER_read}`,
      name: "Teamplaner",
      disabled: false,
      chipsName: "Terminplanung > Teamplaner",
      info: "",
      icon: "",
    },
    {
      id: `${SCHEDULING_ARCHIVE_read}`,
      name: "Archiv",
      disabled: false,
      chipsName: "Terminplanung > Archiv",
      info: "",
      dependencies: [
        `${SCHEDULING_EVENTS_read}`,
        `${AVAILABILITY_REQUESTS_read}`,
      ],
      icon: "",
    },
    {
      id: "terminplanung.konfiguration",
      name: "Konfiguration",
      disabled: false,
      chipsName: "Terminplanung > Konfiguration",
      info: "",
      icon: "",
      children: [
        {
          id: `${SCHEDULING_CONFIG_read}`, //TODO:
          name: "Ansicht (notwendig für Berechtigungen)",
          disabled: false,
          chipsName: "Terminplanung > Konfiguration (Ansicht)",
          info: "",
          icon: "",
        },
        {
          id: `${SCHEDULING_CONFIG_GENERAL_read}`,
          name: "Konfiguration lesen",
          disabled: false,
          chipsName: "Terminplanung > Konfiguration > Allgemein (Lesen)",
          info: "",
          icon: "mdi-eye",
        },
        {
          id: `${SCHEDULING_CONFIG_GENERAL_read}`,
          name: "Konfiguration bearbeiten",
          disabled: false,
          chipsName: "Terminplanung > Konfiguration > Allgemein",
          info: "",
          icon: "mdi-pencil",
        },
        {
          id: "terminplanung.konfiguration.veranstaltungsarten",
          name: "Veranstaltungsarten",
          disabled: false,
          info: "",
          children: [
            {
              id: `${SCHEDULING_CONFIG_EVENT_TYPES_create}`,
              name: "Veranstaltungsarten erstellen",
              disabled: false,
              chipsName:
                "Terminplanung > Konfiguration > Veranstaltungsarten (Erstellen)",
              info: "",
              icon: "mdi-plus-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TYPES_read}`,
              name: "Veranstaltungsarten lesen",
              disabled: false,
              chipsName:
                "Terminplanung > Konfiguration > Veranstaltungsarten (Lesen)",
              info: "",
              icon: "mdi-eye-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TYPES_update}`,
              name: "Veranstaltungsarten bearbeiten",
              disabled: false,
              chipsName:
                "Terminplanung > Konfiguration > Veranstaltungsarten (Bearbeiten)",
              info: "",
              icon: "mdi-pencil-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TYPES_delete}`,
              name: "Veranstaltungsarten löschen",
              disabled: false,
              chipsName:
                "Terminplanung > Konfiguration > Veranstaltungsarten (Löschen)",
              info: "",
              icon: "mdi-delete-circle",
            },
          ],
        },
        {
          id: "terminplanung.konfiguration.vorlagen",
          name: "Vorlagen",
          disabled: false,
          info: "",
          children: [
            {
              id: `${SCHEDULING_CONFIG_EVENT_TEMPLATES_create}`,
              name: "Vorlagen erstellen",
              disabled: false,
              chipsName: "Terminplanung > Konfiguration > Vorlagen (Erstellen)",
              info: "",
              icon: "mdi-plus-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TEMPLATES_read}`,
              name: "Vorlagen lesen",
              disabled: false,
              chipsName: "Terminplanung > Konfiguration > Vorlagen (Lesen)",
              info: "",
              icon: "mdi-eye-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TEMPLATES_update}`,
              name: "Vorlagen bearbeiten",
              disabled: false,
              chipsName:
                "Terminplanung > Konfiguration > Vorlagen (Bearbeiten)",
              info: "",
              icon: "mdi-pencil-circle",
            },
            {
              id: `${SCHEDULING_CONFIG_EVENT_TEMPLATES_delete}`,
              name: "Vorlagen löschen",
              disabled: false,
              chipsName: "Terminplanung > Konfiguration > Vorlagen (Löschen)",
              info: "",
              icon: "mdi-delete-circle",
            },
          ],
        },
        {
          id: "verfuegbarkeit.konfiguration.veranstaltungsarten",
          name: "Abfragearten",
          disabled: false,
          info: "",
          children: [
            {
              id: `${AVAILABILITY_CONFIG_REQUEST_TYPES_create}`,
              name: "Abfragearten erstellen",
              disabled: false,
              chipsName:
                "Verfügbarkeit > Konfiguration > Abfragearten (Erstellen)",
              info: "",
              icon: "mdi-plus-circle",
            },
            {
              id: `${AVAILABILITY_CONFIG_REQUEST_TYPES_read}`,
              name: "Abfragearten lesen",
              disabled: false,
              chipsName: "Verfügbarkeit > Konfiguration > Abfragearten (Lesen)",
              info: "",
              icon: "mdi-eye-circle",
            },
            {
              id: `${AVAILABILITY_CONFIG_REQUEST_TYPES_update}`,
              name: "Abfragearten bearbeiten",
              disabled: false,
              chipsName:
                "Verfügbarkeit > Konfiguration > Abfragearten (Bearbeiten)",
              info: "",
              icon: "mdi-pencil-circle",
            },
            {
              id: `${AVAILABILITY_CONFIG_REQUEST_TYPES_delete}`,
              name: "Abfragearten löschen",
              disabled: false,
              chipsName:
                "Verfügbarkeit > Konfiguration > Abfragearten (Löschen)",
              info: "",
              icon: "mdi-delete-circle",
            },
          ],
        },
      ],
    },
  ],
};
